import { useTrackActivityView } from "@core/activities/hooks/use-track-activity-view.hook";
import { lessonAtom } from "@core/grades/atoms";
import { platformFeaturesAtom } from "@framework/shared/atoms";
import { useState } from "react";
import { useLessonDetails } from "./lesson-details.hooks";

export function useLessonDetailsPage() {
  const { breadcrumbs } = useLessonDetails();
  const lesson = lessonAtom.useValue();
  const platformFeatures = platformFeaturesAtom.useValue();
  const [activeTab, setActiveTab] = useState("content");

  useTrackActivityView("lesson", lesson.id, lesson.name);

  return {
    activeTab,
    breadcrumbs,
    commentsEnabled: platformFeatures.commentsAndRatings === true,
    lesson,
    setActiveTab,
  };
}
